const PERMISSIONS = {
    CAN_VIEW_ABOUT: "view_about",
    CAN_VIEW_EXTRA: "view_extra",
    CAN_ACCESS_ADMIN: "Access_admin",
    CAN_ACCESS_USER_VIEW: "Access_user_view"
  };
  export default PERMISSIONS;
  